@use 'style/utils';
@use './shared' as *;

:host {
    @include rootCheckboxRules();
}

#{$CLASS} {
    @include labelStyle();
    @include checkboxStyle();
    @include checkboxHoverStyle();
    @include checkboxFocusStyle();
    @include checkboxIndeterminateStyle();
    @include checkboxCheckedStyle();
    @include checkboxCheckedActiveStyle();
    @include checkboxDisabledStyle();
    @include checkboxInvalidStyle();
    @include checkboxContentStyle();
}

::slotted(a) {
    @include linksStyle();
}

::slotted(small) {
    @include utils.getFontProperties(primary-200);
}

::slotted([slot="checkbox-error"]) {
    width: 100% !important
}
